/**
 * Constants.ts
 *
 * A module for non-UI constants.
 */

/**
 * Value for the Customer Voice Launcher Type
 */
export const customerVoiceLauncherType = "customervoice";

/**
 * Value for the Customer Voice Survey text for adding to App data
 */
export const customerVoiceSurveyUX = "Customer Voice Survey UX";

/**
 * Values for types of feedback that go into the json
 * Also used to determine the FormTemplate used on each one of the feedback types.
 */
export enum FeedbackType {
	Smile,
	Frown,
	Idea,
	Bug,
	IdeaRedirect,
}

/**
 * Values for types of panels that go into the json
 * Also used to determine the PanelTemplate used on each one of the panel types.
 */
export const enum PanelType {
	Thanks
}

/**
 * Values for the environment
 */
export const enum Environment {
	Production,
	Int
}

/**
 * Values for autodismiss
 */
export const enum AutoDismissValues {
	NoAutoDismiss,
	SevenSeconds,
	FourteenSeconds,
	TwentyOneSeconds,
	TwentyEightSeconds,
	SixtySeconds,
	NinetySeconds,
	OneHundredAndTwentySeconds,
	OneHundredAndFiftySeconds,
}

/**
 * Dynamic scripts
 */
export class DynamicScriptUrls {
	/**
	 * Link to the Office WebSurfaces UX package
	 */
	public static WebSurfacesIntLink = "https://res-sdf.cdn.office.net/office-growth/resources/programmablesurfaces/int/officewebsurfaces.core.min.js";
	public static WebSurfacesProdLink = "https://res.cdn.office.net/office-growth/resources/programmablesurfaces/prod/officewebsurfaces.core.min.js";
}

/**
 * Constant GUIDs
 */
export class GUIDs {
	public static TMSAppID = "4c4f550b-42b2-4a16-93f9-fdb9e01bb6ed";
	public static TULIPSAppID = "05c88d91-956e-46b4-91b0-77a33cc21a4d";
}

export const enum OCPSValues {
	NotConfigured = 0,
	Enabled = 1,
	Disabled = 2
}

export const enum FeedbackStatus {
	Enabled,
	DisabledByAdmin,
	DisabledByAgeGroup
}

/**
 * Prefix for SDK version string
 */
export const SDK_VERSION_PREFIX = "Web SDK v";

/**
 * UxId version constant. (This needs to be changed if a significant UX modification is made.)
 * This is concatenated to the sdkVersion string in the manifest.
 */
export const SDK_UXID_VERSION = "UxId:built-in|comp2022_v1";


/**
 * Default Personalization Sampling Rate to be used if no value is passed in
 */
export const SDK_DEFAULT_PERSONALIZATIONSAMPLINGRATE = 1;

/**
 * Centro default theme string value
 */
export const CentroDefaultTheme = 'M365Light';

/**
 * mapping for feature gate name to feature gate string 
 * Microsoft.Office.SharedOnline will be prepended in host app implementation 
 */
export enum FeatureGateNames {
	TeachingChannelServiceGovernanceEnabled = "TeachingChannelServiceGovernanceEnabled",
	GovernanceLocalUserIdOverride = "GovernanceLocalUserIdOverride",
	GovernanceServiceCheckAllowedCampaignIds = "GovernanceServiceCheckAllowedCampaignIds",
	GovernanceServiceCheckAllowedCampaignIdsExt = "GovernanceServiceCheckAllowedCampaignIdsExt",
	GovernanceServiceEnabledChannels = "GovernanceServiceEnabledChannels",
	GovernanceServiceIntURL = "GovernanceServiceIntURL",
	GovernanceServiceProdURL = "GovernanceServiceProdURL",
	TestBooleanFeatureGate = "DynamicFeatureStatusTestBoolean",
	TestStringFeatureGate = "DynamicFeatureStatusTestString",
	TestIntFeatureGate = "DynamicFeatureStatusTestInt",
}
